export default __webpack_public_path__ + "static/popup-poster-1d692289c7364f342033053e5fbf226f.png";